'use strict';

var $ = require('jquery');
var StepView = require('./step').default;
var Radio = require('backbone.radio');
var polyglot = require('../../utilities/polyglot').default;

var TitleView = require('../step-title').default;
var CalendarView = require('../times/calendar').default;
var StaffView = require('../staff/list-container').default;
var GroupView = require('../group-appointments/list-container').default;
var GroupAppointmentCollection = require('../../collections/group-appointments').default;

export default StepView.extend({

  className: 'l-time-step',
  template: require('./templates/time.hbs'),

  regions: function() {
    return {
      title: '.' + this.className + '-title',
      staff: '.' + this.className + '-staff',
      calendar: '.' + this.className + '-calendar',
    };
  },

  initialize: function(options) {
    var firstStep = Radio.channel('steps').request('first', polyglot.t('pages.times.slug'));
    this.locations = options.locations;
    this.services = options.services;
    this.staff = options.staff;

    if (!window.SETTINGS.show_staff_picker) {
      this.$el.addClass('no-staff-picker');
    }

    this.titleView = new TitleView({
      title: polyglot.t('pages.times.long_title'),
    });

    this.staffView = new StaffView({
      collection: this.staff,
    });

    if (this.appointment.isGroup()) {
      this.calendarView = new GroupView({
        collection: new GroupAppointmentCollection(),
        appointment: this.appointment,
        locations: this.locations,
        services: this.services,
        staff: this.staff,
      });
    } else {
      this.calendarView = new CalendarView({
        collection: this.collection,
        appointment: this.appointment,
        locations: this.locations,
        services: this.services,
        staff: this.staff,
      });
    }

    if (this.appointment.has('staff_id')) {
      this.staffView.setStaffId(this.appointment.get('staff_id'));
    }

    if (!this.appointment.isPrivate()) {
      if (window.STAFF) {
        this.staff.reset([window.STAFF]);
      } else {
        this.fetchStaff();
      }
    }

    if (firstStep) {
      this.showCookieMessage();
    }

    this.listenTo(this.calendarView, 'change:staff', this.onChangeStaff);

    this.listenTo(Radio.channel('steps'), 'click:back', this.resetStaff);
  },

  onRender: function() {
    this.getRegion('title').show(this.titleView);
    this.getRegion('calendar').show(this.calendarView);

    if (!this.appointment.isPrivate() && !this.appointment.isGroup()) {
      this.calendarView.fetchTimes(false);
    }
  },

  onDomRefresh: function() {
    if (this.appointment.isPrivate()) {
      this.calendarView.hideLoadingView();
    }
  },

  fetchStaff: function() {
    var self = this;
    this.staff.fetch({
      data: {
        location_id: this.appointment.get('location_id'),
        service_id: this.appointment.get('service_id'),
      },
      reset: true,
      success: function(collection, data) {
        if (data.data.staff.length === 0) {
          self.calendarView.hideLoadingView();
          $('.calendar-empty').show();
        }
      },
      error: function() {
        self.calendarView.hideLoadingView();
      }
    });
  },

  onChangeStaff: function (staff) {
    if (staff && staff.id) {
      this.appointment.setStaff(staff);
    } else {
      this.appointment.unsetStaff();
    }

    if (this.appointment.isGroup()) {
      this.calendarView.fetchTimes(staff);
    } else {
      this.calendarView.fetchTimes(false);
    }
    Radio.channel('calendar-collection').trigger('setInitialLoad', true);
    this.appointment.unset('start');
  },

  resetStaff: function() {
    this.staff.reset();

    if (!window.STAFF) {
      this.appointment.unsetStaff();
    }
  },
});
